export default __webpack_public_path__ + "static/media/css.cd355072.svg";